// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
    width: 150px;
}

.acciones {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-content: stretch;
    align-items: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/app/core/mensajes/mensaje-default/mensaje-default.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IAGI,aAAa;IAGb,mBAAmB;IAGnB,iBAAiB;IAGjB,yBAAyB;IAGzB,sBAAsB;IAGtB,uBAAuB;AAC3B","sourcesContent":["button {\r\n    width: 150px;\r\n}\r\n\r\n.acciones {\r\n    display: -ms-flexbox;\r\n    display: -webkit-flex;\r\n    display: flex;\r\n    -webkit-flex-direction: row;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    -webkit-flex-wrap: nowrap;\r\n    -ms-flex-wrap: nowrap;\r\n    flex-wrap: nowrap;\r\n    -webkit-justify-content: flex-end;\r\n    -ms-flex-pack: end;\r\n    justify-content: flex-end;\r\n    -webkit-align-content: stretch;\r\n    -ms-flex-line-pack: stretch;\r\n    align-content: stretch;\r\n    -webkit-align-items: flex-start;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
